import instance from "../utils/network";
import { TournamentResponse } from "./tournament";

export interface DashboardReservationDto {
  dayOfWeek: string;
  count: number;
}

export interface DashboardSummaryDto {
  todayReservationCount: number;
  weekReservationCount: number;
  monthReservationCount: number;
}
export interface DashboardResponse {
  reservation: DashboardReservationDto[];
  tournament: TournamentResponse[];
  summary: DashboardSummaryDto;
  todayDifference: number;
}

export function getDashboard(
  pubId: number,
  type: string
): Promise<DashboardResponse> {
  return instance.get(`/seller/dashboard/${pubId}?type=${type}`);
}
